import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Flex,
  Button,
  Input,
  FormLabel,
  Tabs,
  TabList,
  Tab,
  TabPanel,
  FormControl,
  TabPanels,
  Tag,
} from "@chakra-ui/react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css"; // Import the styles for the layout

// Import styles
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import Changelog from "./Changelog";
import CloseModalArrow from "../general/CloseModalArrow";

const FullScreenReportModal = ({
  isOpen,
  onClose,
  reportData,
  fundName,
  reportType,
}) => {
  // Initialize the default layout plugin
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const isNewReport = reportData?.isNew;


  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />
      <ModalContent h="100vh" overflow={"hidden"}>
        <ModalBody p={0}>
          <Flex direction="row" w="100%" h="100%" gap={8}>
            <Flex direction="column" gap={8} p={8} w={"520px"}>
              <Flex gap={4} align={"center"}>
                <CloseModalArrow onClose={onClose} />
                {/* Use fundName and reportType for existing reports or fallback to reportData */}
                <h4>
  {isNewReport
    ? reportData?.reportName?.label || reportData?.reportType?.label || "New Report"
    : typeof reportData?.reportType === "object"
    ? reportData.reportType.label
    : reportData.reportType}
</h4>

<Tag colorScheme="brand">
  {typeof reportData?.fund === "object"
    ? reportData.fund.label
    : reportData?.fund || "No Fund"}
</Tag>

              </Flex>

              <Tabs colorScheme="brand" variant="solid-rounded">
                <TabList bg={"grey.100"} borderRadius={8} p={1} w={"fit-content"}
                sx={{
                  "button": {
                    borderRadius: 4,
                    fontWeight: "500",
                    color: "grey.500"
                  },
                  "button[aria-selected=true]": {
                    bg: "white",
                    color: "brand.700",
                    boxShadow: "sm"
                  }
                }}>
                  <Tab>General</Tab>
                  <Tab>Send history</Tab>
                  <Tab>Changelog</Tab>
                </TabList>

                <TabPanels>
                  <TabPanel gap={4} as={Flex} flexDirection={"column"} py={8}>
                    <FormControl>
                      <FormLabel>Report Title</FormLabel>
                      <Input
  placeholder="Enter report title"
  defaultValue={
    typeof reportData?.reportType === "object"
      ? reportData.reportType.label
      : reportData?.reportType || "New Report"
  }
/>

                    </FormControl>

                    <FormControl>
                      <FormLabel>Fund Name</FormLabel>
                      <Input
  placeholder="Fund name"
  defaultValue={
    typeof reportData?.fund === "object"
      ? reportData.fund.label
      : reportData?.fund || "Select Fund"
  }
  isDisabled
/>

                    </FormControl>
                  </TabPanel>

                  <TabPanel gap={4} as={Flex} flexDirection={"column"} py={8}></TabPanel>
                  <TabPanel gap={4} as={Flex} flexDirection={"column"} py={8}><Changelog /></TabPanel>

                </TabPanels>
              </Tabs>
              <Button colorScheme="brand" mt={4} onClick={onClose}>
                Save changes
              </Button>
            </Flex>

            {/* Right Section: PDF Viewer */}
            <Flex
              flex={2}
              bg="white"
              borderRadius="md"
              justifyContent="center"
              alignItems="center"
              h={"100vh"}>
              <Worker workerUrl={`/pdf/pdf.worker.min.js`}>
                <Viewer
                  theme="dark"
                  fileUrl="/pdf/pdfPreview.pdf"
                  plugins={[defaultLayoutPluginInstance]}
                />
              </Worker>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default FullScreenReportModal;
